import React, { useState, useEffect } from 'react';
import { signOut, onAuthStateChanged } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { FaBoxOpen, FaPlusCircle, FaSignOutAlt, FaHome, FaTags, FaCalendarAlt } from 'react-icons/fa'; // FaCalendarAlt eklendi
import ProductList from '../ProductList/ProductList';
import AddProduct from '../AddProduct/AddProduct';
import CategoryManager from '../CategoryManager/CategoryManager';
import MezatManager from '../MezatManager/MezatManager'; // Yeni bileşeni import ettik
import { auth } from '../firebase/firebase-config';
import './AdminPanel.css';

const AdminPanel = () => {
  const [activeTab, setActiveTab] = useState('list');
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      if (!currentUser) navigate('/login');
      else setUser(currentUser);
    });
    return () => unsubscribe();
  }, [navigate]);

  // Çıkış yapma fonksiyonu kanka
  const handleLogout = () => {
    if(window.confirm("Güvenli çıkış yapıyorsun kral, emin misin?")) {
      signOut(auth);
    }
  };

  return (
    <div className="admin-layout">
      <aside className="admin-sidebar">
        <div className="sidebar-header">
          <span>TESBİHÇİMEN PANEL</span>
        </div>
        <nav className="sidebar-nav">
          <button 
            className={activeTab === 'list' ? 'active' : ''} 
            onClick={() => setActiveTab('list')}
          >
            <FaBoxOpen /> Ürünler
          </button>
          
          <button 
            className={activeTab === 'add' ? 'active' : ''} 
            onClick={() => setActiveTab('add')}
          >
            <FaPlusCircle /> Ürün Ekle
          </button>
          
          <button 
            className={activeTab === 'cats' ? 'active' : ''} 
            onClick={() => setActiveTab('cats')}
          >
            <FaTags /> Kategoriler
          </button>

          {/* Yeni Mezat ve İstatistik Sekmesi kanka */}
          <button 
            className={activeTab === 'mezat' ? 'active' : ''} 
            onClick={() => setActiveTab('mezat')}
          >
            <FaCalendarAlt /> Mezat & Sayılar
          </button>

          <button onClick={() => navigate('/')}>
            <FaHome /> Siteyi Gör
          </button>
        </nav>
        
        <button className="logout-btn" onClick={handleLogout}>
          <FaSignOutAlt /> Çıkış
        </button>
      </aside>

      <main className="admin-main">
        <header className="main-header">
          <h2>
            {activeTab === 'list' ? 'Koleksiyon Listesi' : 
             activeTab === 'add' ? 'Yeni Eser Kaydı' : 
             activeTab === 'cats' ? 'Kategori & Vitrin Yönetimi' : 
             'Mezat Programı & İstatistikler'}
          </h2>
          <div className="user-info">Admin: <strong>{user?.email}</strong></div>
        </header>

        <div className="content-area">
          {activeTab === 'list' && <ProductList />}
          {activeTab === 'add' && <AddProduct />}
          {activeTab === 'cats' && <CategoryManager />}
          {activeTab === 'mezat' && <MezatManager />}
        </div>
      </main>
    </div>
  );
};

export default AdminPanel;